import convert from 'color-convert';


export default class Color {

    constructor(rgb) {
        this.rgbValue = rgb;
    }

    hsl() {
        let rgb = this.rgb();
        let hsl = convert.rgb.hsl(rgb.red, rgb.green, rgb.blue);
        return {
            hue: hsl[0],
            saturation: hsl[1],
            lightness: hsl[2],
        }
    }

    rgb() {
        return {
            red: this.rgbValue.red,
            green: this.rgbValue.green,
            blue: this.rgbValue.blue,
        };
    }

    hsv() {
        let rgb = this.rgb();
        let hsv = convert.rgb.hsv(rgb.red, rgb.green, rgb.blue);
        return {
            hue: hsv[0],
            saturation: hsv[1],
            value: hsv[2],
        }
    }

    hex() {
        let rgb      = this.rgb();
        let hexValue = convert.rgb.hex(rgb.red, rgb.green, rgb.blue);
        return {
            value: '#' + hexValue,
        }
    }

    static fromRGB(rgb) {
        return new Color(rgb);
    }

    static fromHSL(hsl) {
        let rgb = convert.hsl.rgb(hsl.hue, hsl.saturation, hsl.lightness);

        return new Color({red: rgb[0], green: rgb[1], blue: rgb[2]});
    }

    static fromHSV(hsv) {
        let rgb = convert.hsv.rgb(hsv.hue, hsv.saturation, hsv.value);

        return new Color({red: rgb[0], green: rgb[1], blue: rgb[2]});
    }

    static fromHex(hex) {
        let rgb = convert.hex.rgb(hex.value);

        return new Color({red: rgb[0], green: rgb[1], blue: rgb[2]});
    }

    static ensureColor(color) { // if it's not an instance of Color assume it's an rgb value.
        return color instanceof Color ? color : new Color(color);
    }

}
